__turbopack_context__.v({
  "actionButton": "_3TkQMa_actionButton",
  "indicatorIndicator": "_3TkQMa_indicatorIndicator",
  "indicatorRoot": "_3TkQMa_indicatorRoot",
  "label": "_3TkQMa_label",
  "opened": "_3TkQMa_opened",
});
